import { render, staticRenderFns } from "./toolbar-btn.vue?vue&type=template&id=05f8a036&scoped=true&"
import script from "./toolbar-btn.vue?vue&type=script&lang=ts&"
export * from "./toolbar-btn.vue?vue&type=script&lang=ts&"
import style0 from "./toolbar-btn.vue?vue&type=style&index=0&id=05f8a036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f8a036",
  null
  
)

export default component.exports